import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AgentDashboard from "@/pages/AgentDashboard";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/agent-dashboard")({
  head: () => seoHead("/agent-dashboard"),
  component: () => (
    <AuthGate><AgentDashboard /></AuthGate>
  ),
});
